import { SearchBookingOverview, SearchFlightRecommendationResponse, SearchHotelPensionResponse, SearchHotelTransfersResponse, SearchTravelBookingRequest, SearchTravelPriceResponse, SearchTravelRequest, SearchTravelResponse, SearchTravelBookingSelection, SearchHotelRoomsResponse } from '@/types/models';
import http from "@/http/http-portal-api";
import ResponseData from "@/types/IResponseData";
import { SearchTravelFilterRequest } from '@/types/paramModels';

class TravelService {
  getDefaultSearchRequest(): Promise<ResponseData<SearchTravelRequest>> {
    return http.get("travel/search-default-request");
  }
  getSearchTravelResponse(searchTravelRequest: SearchTravelRequest): Promise<ResponseData<SearchTravelResponse>> {
    return http.post("/travel/search", searchTravelRequest);
  }
  getFilterSearchTravelResponse(searchTravelRequest: SearchTravelFilterRequest): Promise<ResponseData<SearchTravelResponse>> {
    return http.post("/travel/search-by-filtering", searchTravelRequest);
  }
  getSearchTravelOverview(searchTravelBookingSelection: SearchTravelBookingSelection): Promise<ResponseData<SearchBookingOverview>> {
    return http.post("/travel/search-travel-overview", searchTravelBookingSelection);
  }
  getSearchTravelHotelRooms(searchTravelBookingSelection: SearchTravelBookingSelection): Promise<ResponseData<SearchHotelRoomsResponse>> {
    return http.post("/travel/search-hotel-rooms", searchTravelBookingSelection);
  }
  getSearchHotelPensions(searchTravelBookingSelection: SearchTravelBookingSelection): Promise<ResponseData<SearchHotelPensionResponse>> {
    return http.post("/travel/search-hotel-pensions", searchTravelBookingSelection);
  }
  getSearchTravelHotelFlights(searchTravelBookingSelection: SearchTravelBookingSelection): Promise<ResponseData<SearchFlightRecommendationResponse>> {
    return http.post("/travel/search-hotel-flights", searchTravelBookingSelection);
  }
  getFilterSearchTravelHotelFlights(searchFlightRecommendationRequest: SearchFlightRecommendationResponse): Promise<ResponseData<SearchFlightRecommendationResponse>> {
    return http.post("/travel/search-hotel-flights-by-filtering", searchFlightRecommendationRequest);
  }
  getSearchTravelHotelTransfers(searchTravelBookingSelection: SearchTravelBookingSelection): Promise<ResponseData<SearchHotelTransfersResponse>> {
    return http.post("/travel/search-hotel-transfers", searchTravelBookingSelection);
  }
  getSearchCalculatedPrice(searchTravelBookingSelection: SearchTravelBookingSelection): Promise<ResponseData<SearchTravelPriceResponse>> {
    return http.post("/travel/search-calculate-travel-price", searchTravelBookingSelection);
  }
  bookTravel(searchTravelBookingRequest: SearchTravelBookingRequest): Promise<ResponseData<any>> {
    return http.post("/travel/book", searchTravelBookingRequest);
  }
}

export default new TravelService();